import MaintenanceError from "@/components/errors/maintenance-error";
import { createRoute } from "@tanstack/react-router";
import { errorLayoutRoute } from "../__root";
import { ROUTER_HELPERS } from "@/shared/constants/router";

export const maintenanceErrorRoute = createRoute({
  getParentRoute: () => errorLayoutRoute,
  path: ROUTER_HELPERS.error(503),
  component: MaintenanceError,
});
